/* eslint-disable space-in-parens */
// /* eslint-disable yoda */
// /* eslint-disable space-in-parens */
// /* eslint-disable indent */

import '../../css/style.scss'


jQuery(document).ready(function($) {

	$('.toggle-nav').on('click', function(e) {
		e.preventDefault();
		$(this).toggleClass('is-active');

		$('.navbar-collapse').toggleClass('nav-open');

	});

	$('.search-icon').on('click', function() {

		$('.search-modal').slideDown('fast');

	});

	$('.close-search').on('click', function() {

		$('.search-modal').slideUp('fast');

	});

});

